import { createFileRoute, redirect } from '@tanstack/react-router';
import { SUPERVISOR_ROLES, MANAGEMENT_ROLES } from '@munawb/hooks';
import type { UserRole } from '@munawb/types';
import LoginPage from '../pages/LoginPage';
import { getProfileSync } from '../lib/getProfileSync';

export const Route = createFileRoute('/')({
  beforeLoad: ({ context: _ctx }) => {
    // إذا كان المستخدم مسجلاً دخل → وجّهه للصفحة الصحيحة
    const profile = getProfileSync();
    if (profile?.status === 'active') {
      throw redirect({ to: getRoleRoute(profile.role) });
    }
  },
  component: LoginPage,
});

export function getRoleRoute(role: UserRole): string {
  if (role === 'Admin')                       return '/admin';
  if (role === 'Executive')                   return '/executive';
  if (role === 'QualitySuper')                return '/quality';
  if (role === 'DutyManager')                 return '/duty-manager';
  if (role === 'Manager')                     return '/duty-manager';
  if (SUPERVISOR_ROLES.includes(role))        return '/supervisor';
  return '/employee';
}
